"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./style.scss");
const body = document.body;
const header = document.querySelector('.header');
const burger = document.querySelector('.header__burger');
const navList = document.querySelector('.header__nav-list');
const specialStock = document.querySelector('.equipment__stock--special');
const loader = document.querySelector('.loader');
const startTime = Date.now();
const checkScreenSize = () => {
    const isDesktop = window.innerWidth >= 1440;
    if (isDesktop && navList && burger && header) {
        navList.classList.remove('header__nav-list--active');
        burger.classList.remove('header__burger--active');
        header.classList.remove('header--nav-open');
        body === null || body === void 0 ? void 0 : body.classList.remove('body--nav-open');
    }
    if (specialStock) {
        if (window.innerWidth < 768) {
            specialStock.textContent = 'В наличии 50 м.';
            specialStock.classList.remove('equipment__stock--order');
        }
        else {
            specialStock.textContent = 'Под заказ';
            specialStock.classList.add('equipment__stock--order');
        }
    }
};
document.addEventListener('DOMContentLoaded', () => {
    if (burger && navList && header) {
        burger.addEventListener('click', () => {
            if (window.innerWidth >= 1440)
                return;
            const isActive = navList.classList.toggle('header__nav-list--active');
            burger.classList.toggle('header__burger--active');
            header.classList.toggle('header--nav-open');
            body === null || body === void 0 ? void 0 : body.classList.toggle('body--nav-open');
            if (isActive) {
                window.scrollTo(0, 0);
            }
        });
    }
    checkScreenSize();
});
window.addEventListener('load', () => {
    if (loader) {
        const elapsedTime = Date.now() - startTime;
        const minimumTime = 1000;
        const remainingTime = Math.max(0, minimumTime - elapsedTime);
        setTimeout(() => {
            loader.classList.add('loader--hidden');
        }, remainingTime);
    }
});
window.addEventListener('resize', checkScreenSize);
